import styled from 'styled-components'

export const StyledShopTimeSlot = styled.div`
	& .rt-tr .rt-th, .rt-tr-group .rt-tr-group .rt-tr .rt-td{
        width: auto !important;
        flex: 0 0 130px !important;
        &:nth-child(5){
            flex: 0 0 153px !important;
        }
        &:nth-child(6){
            flex: 1 1 153px !important;
        }
        &:last-child{
            flex: 0 0 auto !important;
        }
    }
`

